export default __webpack_public_path__ + "static/media/playstoreIconNew.6efb8986.svg";